import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher, Fetch } from '@weezevent/weezjs-core';

export default class DownloadModel extends BaseAPIModel {
    getInfo({ uuid = null, organizationId = null, eventId = null }) {
        // Our fetch lib just transforms any non json api reply to text. This patched
        // copy tries to read text files as text, and the rest (like pdf files) as blobs.
        // We wait for the first call to build the copy, to make sure that the credentials
        // exist on fetcher.
        const specialFetcher = new Fetch(fetcher.authorizationHeader, fetcher.endpoint, fetcher.language);
        specialFetcher.parse_response = response => {
            const contentType = response.headers.get('Content-type') || '';
            if (contentType.includes('application/json')) {
                return response.json();
            }
            if (contentType.includes('text')) {
                return response.text();
            }
            return response.blob();
        };

        let params = { uuid };
        if (eventId && organizationId) {
            params = { ...params, organizationId, eventId };
        }
        const url = this.constructor.getDownloadUrl(params);
        return specialFetcher.get(url, { cache: false }).then(({ response }) => {
            this.data_info = response;
            return this;
        });
    }

    static getDownloadUrl({ uuid, organizationId, eventId }) {
        if (!uuid) {
            throw new ArgumentError(`[Model][Download] uuid is mandatory`);
        }
        if (organizationId && eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/utils/download/${uuid}`;
        }
        return `/ticket/utils/download/${uuid}`;
    }
}
